module.exports = __webpack_public_path__ + "assets/img/42a3762033e99543ed49a607556e803d.svg";